import Link from "next/link";
import React from "react";

export default function PostsCardMini({
    imageUrl,
    tags,
    title,
    author,
    date,
    slugUrl
}) {    
    return (

        <Link href={`/blog/${slugUrl}`} className="mini_card_main_container">
            <div className="mini_article_card">
                <div className="mini_article_image_container">
                    <img alt={`Image de l'article ${title}`} src={imageUrl} />
                </div>
                <div className="mini_article_info_container">
                    <h2 className="mini_article_title">{title}</h2>
                    <div className="mini_articles_tags_container">
                        <div className="mini_articles_tags">
                            <p>{tags}</p>
                        </div>
                    </div>
                    <p className="mini_article_author">écrit par <b>{author}</b></p>
                    <p className="mini_article_date">{date}</p>
                </div>
            </div>
        </Link>
    );
}